import { Action, createReducer, on } from '@ngrx/store';

import { IGenericError, ErrorResponse } from 'src/app/core/models/generic-models';
import { loadCurrentSelfieRequest, loadCurrentSelfieResponse, loadCurrentSelfieFailure } from '../actions/selfie.actions';
import { IEmployeeParams, ICurrentSelfieResponse } from '../models/selfie.model';

export const selfieFeatureKey = 'selfie';

export interface CurrentSelfieState {
  currentSelfieRequest: string;
  currentSelfieResponse: ICurrentSelfieResponse;
  currentSelfieFailure: IGenericError<ErrorResponse>;
}

export const initialState: CurrentSelfieState = {
  currentSelfieRequest: undefined,
  currentSelfieResponse: undefined,
  currentSelfieFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(loadCurrentSelfieRequest, (state, action) => ({
    ...state,
    currentSelfieRequest: action.request
  })),
  on(loadCurrentSelfieResponse, (state, action) => ({
    ...state,
    currentSelfieResponse: action.response
  })),
  on(loadCurrentSelfieFailure, (state, action) => ({
    ...state,
    currentSelfieFailure: action.error
  }))
);

export const getCurrentSelfieRequest = (state: CurrentSelfieState) => state.currentSelfieRequest;
export const getCurrentSelfieResponse = (state: CurrentSelfieState) => {
  return state.currentSelfieResponse;
};
export const getCurrentSelfieFailure = (state: CurrentSelfieState) => state.currentSelfieFailure;
